import React from 'react';
import PureComponent from 'components/PureComponent';


class Button extends PureComponent {

	render() {
		require('./Button.styl');
		const { component: Component = 'button', ...props } = this.props;
		return (
			<Component className="Button" {...props}>
				{this.props.children}
			</Component>
		);
	}

}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.js